import { useMemo } from 'react';

export interface GetDocumentDetailRow {
  uuid?: string | null;
  [key: string]: any;
}

const getDetailRowId = (row: GetDocumentDetailRow, index: number) =>
  row.uuid ||
  row.id ||
  [row.line, row.ma_vt, row.ma_kho, row.so_ct_hd4, row.so_ct_hd5, row.so_ct_hd7, index].filter(Boolean).join('-') ||
  `detail-row-${index}`;

export function useDetailRows(rows: GetDocumentDetailRow[] = []) {
  return useMemo(
    () =>
      rows.map((row, index) => ({
        ...row,
        uuid: String(getDetailRowId(row, index))
      })),
    [rows]
  );
}
